<div
  *ngIf="content.notification.success === false"
  auraRibbon
  [auraRibbonColor]="'danger'"
  [auraRibbonPosition]="'top'"
  class="miles_rollover_error"
>
  <div class="miles_rollover_error--container">
    <img class="custom-tooltip__icon" alt="alert icon" />
    <div class="miles_rollover_error__label">
      {{ content.notification.errorMessage }}
    </div>
  </div>
  <button
    class="custom-tooltip__close"
    (click)="closeError.emit()"
    (keydown.enter)="closeError.emit()"
  >
    <span class="sr-only">Close</span>
  </button>
</div>
<div *ngIf="showModal">
  <aura-modal
    [headerTemplate]="modalData"
    [outsideClick]="false"
    (opened)="opened($event)"
    (dismiss)="close()"
  ></aura-modal>
  <ng-template #modalData>
    <div class="options__modal__container" tabindex="0">
      <div class="options__modal__container__close">
        <button
          (click)="close()"
          class="options__modal__container__close--button"
          *ngIf="!confirm || (confirm && content.notification.success)"
          [attr.aria-label]="content.review.ariaLabel.close"
        ></button>
      </div>
      <idp-review
        *ngIf="!confirm"
        [content]="content.review"
        (closeModal)="close()"
        (confirm)="onConfirm(); closeError.emit()"
      ></idp-review>

      <div *ngIf="confirm">
        <div
          auraSkeletonLoader
          [skeletonMetaData]="{
            loaded: !!content.notification.success,
            error: undefined,
            disabled: !content.notification.success
          }"
        >
          <idp-notification [content]="content.notification"></idp-notification>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div
  class="rollover-options"
  *ngIf="
    content.notification.success === undefined ||
    content.notification.success === false
  "
>
  <form [formGroup]="content.form" (ngSubmit)="onSubmit(content, tooltip)">
    <div
      class="rollover-options__wrapper"
      *ngFor="
        let step of content.steps;
        let index = index;
        let last = last;
        trackBy: getTrackByIndex
      "
    >
      <div
        #tooltip
        *ngIf="step.content.controlName === 'conversion'"
        class="rollover-options__tooltip"
        auraTooltip
        [template]="customTooltip"
        [tooltipContent]="{
          position: 'top-left',
          info: '',
          keepOpen: true
        }"
      ></div>
      <ng-template #customTooltip>
        <div class="custom-tooltip">
          <img class="custom-tooltip__icon" alt="alert icon" />
          <div class="custom-tooltip__text">
            {{ step.content.errorMessage }}
          </div>
        </div>
      </ng-template>
      <div auraStep [auraStepContent]="step"></div>
      <div
        *ngIf="step.content.controlName === 'extension'; else conversion"
        class="rollover-options__extension"
      >
        <div
          class="select-error-tooltip"
          auraTooltip
          [template]="customTooltip"
          (detachTooltip)="displayTooltip = false"
          [tooltipContent]="{
            position: 'top-left',
            info: '',
            keepOpen: true,
            open:
              submitAttempt &&
              content.form.controls['extension'].invalid &&
              displayTooltip
          }"
        ></div>
        <ng-template #customTooltip>
          <div class="select-error-tooltip-content" errorTemplate>
            <img class="select-error-tooltip-content__icon" alt="alert icon" />
            <div class="select-error-tooltip-content__text">
              {{ step.content.errorMessage }}
            </div>
          </div>
        </ng-template>
        <aura-select
          #auraSelect
          [placeholder]="placeholderText"
          [content]="dropdownOptions"
          [submitted]="submitAttempt"
          [title]="''"
          [formControlName]="step.content.controlName"
          (action)="change($event)"
          (active)="active($event, content.form.invalid)"
        ></aura-select>
      </div>
      <ng-template #conversion>
        <div class="rollover-options__conversion">
          <div
            *ngFor="
              let item of getRadioGroup(step.content.feature);
              let index = index
            "
            class="rollover-options__conversion__item"
          >
            <input
              auraRadio
              type="radio"
              [id]="item.code"
              [formControlName]="step.content.controlName"
              [name]="step.content.controlName"
              [value]="item"
              [attr.aria-label]="item.title + ' ' + item.subtitle"
            />
            <label [for]="item.code" class="aura-radio-label">
              <div class="rollover-options__conversion__item__label__detail">
                <span
                  class="rollover-options__conversion__item__label__detail__title"
                >
                  {{ item.title }}
                </span>
                <span
                  class="rollover-options__conversion__item__label__detail__subtitle"
                >
                  {{ item.subtitle }}
                </span>
              </div>
            </label>
          </div>
        </div>
      </ng-template>
      <div class="rollover-options__divider" *ngIf="!last">
        <aura-divider></aura-divider>
      </div>
    </div>
    <button
      class="rollover-options__continue"
      type="submit"
      auraButton
      [buttonColor]="'primary'"
      [buttonOutlineColor]="'primary'"
      [buttonSize]="'medium'"
      [id]="content.action.id"
    >
      {{ content.action.label }}
    </button>
  </form>
</div>
